
import { Component, Vue } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class Recharge extends Vue {
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
}
